var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAddToRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.18.2a.73.73 0 0 0 0 .94L13.55 6l-4.37 4.86a.7.7 0 0 0-.18.47c0 .18.06.35.18.47.1.13.26.2.42.2.16 0 .31-.07.43-.2l4.8-5.33c.05-.06.1-.13.12-.21a.73.73 0 0 0-.13-.73L10.02.2a.6.6 0 0 0-.19-.15.55.55 0 0 0-.46 0 .6.6 0 0 0-.2.15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2 3.1a.7.7 0 1 0-1.4 0v2.1H.7a.7.7 0 1 0 0 1.4h2.1v2.1a.7.7 0 1 0 1.4 0V6.6h2.1a.7.7 0 1 0 0-1.4H4.2V3.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddToRight);
export default ForwardRef;